package com.essntl.features.itinerary.ui.edit_itinerary.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.DialogProperties
import com.essntl.features.proposal.ui.selectservice.SelectServiceEvent
import com.essntl.features.proposal.ui.selectservice.SelectServiceNavigation
import com.essntl.features.proposal.ui.selectservice.SelectServiceState
import com.essntl.features.proposal.ui.selectservice.components.ServiceColumn
import com.essntl.features.supplier.ui.allsuppliers.AllSuppliersEvent
import com.essntl.features.supplier.ui.allsuppliers.AllSuppliersState
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SelectServicePopup(
    openDialog: Boolean,
    isLoading: Boolean,
    onDismissRequest: () -> Unit,
    state: SelectServiceState,
    selectServiceEvent: (SelectServiceEvent) -> Unit,
    onNavigation: (SelectServiceNavigation) -> Unit,
    allSuppliersState: AllSuppliersState,
    onEventAllSuppliers: (AllSuppliersEvent) -> Unit,
) {
    if (openDialog) {
        LaunchedEffect(Unit) {
            selectServiceEvent(SelectServiceEvent.GetAllService)
        }

        BasicAlertDialog(
            onDismissRequest = onDismissRequest,
            properties = DialogProperties(
                usePlatformDefaultWidth = false,
            ),
            modifier = Modifier.fillMaxSize(0.7f),
        ) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(25.dp)),
            ) {
                Column(
                    horizontalAlignment = Alignment.Start,
                    verticalArrangement = Arrangement.Center,
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(color = MaterialTheme.esColorScheme.bgPrimary)
                        .padding(bottom = 1.spacing),
                ) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(color = Color.White)
                            .padding(
                                vertical = 3.spacing,
                                horizontal = 2.5.spacing,
                            ),
                    ) {
                        Text(
                            text = "Select service",
                            style = MaterialTheme.esTypography.h3Bold24,
                            color = MaterialTheme.esColorScheme.textPrimary,
                            modifier = Modifier.align(Alignment.CenterStart),
                        )

                        EsSmallOutlineIconButton(
                            onClick = {
                                onDismissRequest()
                            },
                            iconRes = EsIcons.Close,
                            modifier = Modifier.align(Alignment.CenterEnd),
                        )
                    }
                    if (isLoading)
                        Box(modifier = Modifier.fillMaxSize()) {
                            EsSpinner(
                                modifier = Modifier.align(Alignment.Center),
                            )
                        }
                    else
                        ServiceColumn(
                            state = state,
                            onNavigation = onNavigation,
                            onEvent = selectServiceEvent,
                            allSupplierState = allSuppliersState,
                            onEventAllSupplier = onEventAllSuppliers,
                        )
                }
            }
        }
    }
}